import type { LiveSheetItem } from "../../types/generated/live";
import type { Edits } from "./edits";
import { interpolate, type Labels } from "./labels";

// Where an item can go from its menu. A sheet has one destination, its campaign; the campaign's has a sheet to choose from
// (`choices`), and the destination's own words come with it.
export type Mover = {
	entry: string;
	hint: string;
	// What the choice is called, when there is one.
	choose?: string;
	choices: { value: string; label: string }[];
	move: string;
	copy: string;
	moved: string;
	copied: string;
	// Whether the item leaves where it is by default: the sheet's move does, the campaign's, as the old form did, only copies.
	remove: boolean;
	run: (choice: string, remove: boolean) => Promise<boolean>;
};

const sheetMover = (labels: Labels, edits: Pick<Edits, "moveItem">, item: LiveSheetItem): Mover => ({
	entry: labels.item.menu_move,
	hint: interpolate(labels.item.move_hint, { name: item.name }),
	choices: [],
	move: labels.item.menu_move,
	copy: labels.item.menu_copy,
	moved: labels.item.moved,
	copied: labels.item.copied,
	remove: true,
	run: (_choice, remove) => edits.moveItem(item.id, remove),
});

// A sheet in a campaign moves its items there; one outside any has nowhere to send them.
export const sheetMoves = (campaignId: string | null, labels: Labels, edits: Pick<Edits, "moveItem">) =>
	campaignId ? (item: LiveSheetItem) => sheetMover(labels, edits, item) : undefined;
